export const IsSubDomain = () => {
  const urlpart = window.location.host.split(".")[1];

  switch (urlpart) {
    case "dev":
      const IsSuccessorsubDomaindev =
        window.location.host.split(".")[0] !== "pe2" &&
        window.location.host.split(".")[0] !== "pe2-react-test"
          ? true
          : false;
      return {
        isSubDomin: IsSuccessorsubDomaindev,
        subDomain: IsSuccessorsubDomaindev
          ? window.location.host.split(".")[0]
          : "",
        domain: window.location.host.slice(
          window.location.host.indexOf(".") + 1,
        ),
      };
      break;
    case "beta":
    case "qa":
    case "stage":
    case "pruefexpress":
      const IsSuccessorsubDomain =
        window.location.host.split(".")[0] !== "pe2" ? true : false;
      return {
        isSubDomin: IsSuccessorsubDomain,
        subDomain: IsSuccessorsubDomain
          ? window.location.host.split(".")[0]
          : "",
        domain: window.location.host.slice(
          window.location.host.indexOf(".") + 1,
        ),
      };
      break;
    case "localhost:3000":
      return {
        isSubDomin: true,
        subDomain: window.location.host.split(".")[0],
        domain: window.location.host,
      };
      break;
    default:
      return {
        isSubDomin: false,
        subDomain: "",
        domain: window.location.host.includes("localhost")
          ? window.location.host
          : window.location.host.slice(window.location.host.indexOf(".") + 1),
      };
      break;
  }
};
